import React from "react";

import { Chip } from "@material-ui/core";

const OperatorsList = ({ currentAudit, locations, classes }) => {
  return currentAudit?.nextItems ? (
    <div className={classes.operators}>
      {currentAudit.nextItems.map((item, idx) => {
        return (
          <div key={item.owner} className={classes.item}>
            <Chip
              variant="outlined"
              label={
                item.owner +
                " - " +
                window.appUser.reloadYard.locationMap[
                  locations[item.locationIdx]
                ].name
              }
            />
          </div>
        );
      })}
    </div>
  ) : (
    <></>
  );
};

export default OperatorsList;
